import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

function initPageGalleryMasonry() {
  const gallery = document.querySelector('.js-page-gallery');
  if (!gallery) return;

  const items = gallery.querySelectorAll('.js-page-gallery-item');
  if (!items.length) return;

  let msnry = null;

  imagesLoaded(gallery, () => {
    msnry = new Masonry(gallery, {
      itemSelector: '.js-page-gallery-item',
      columnWidth: '.page-gallery-sizer',
      percentPosition: true,
      gutter: 0,
    });
  });

  imagesLoaded(gallery).on('progress', () => {
    if (msnry) {
      msnry.layout();
    }
  });
}

function initPageGalleryModal() {
  const $modal = $('#pageGalleryModal');
  const $modalImage = $('#pageGalleryModalImage');

  if (!$modal.length || !$modalImage.length) return;

  $(document).on('click', '.js-gallery-open', function (e) {
    e.preventDefault();

    const image = $(this).data('image');
    const alt = $(this).data('alt') || '';

    $modalImage.attr('src', image);
    $modalImage.attr('alt', alt);

    $modal.modal('show');
  });

  $modal.on('show.bs.modal', function () {
    $('html, body').addClass('page-gallery-modal-open');
  });

  $modal.on('hidden.bs.modal', function () {
    $modalImage.attr('src', '');
    $modalImage.attr('alt', '');
    $('html, body').removeClass('page-gallery-modal-open');
  });
}

export default function initPageGallery() {
  initPageGalleryMasonry();
  initPageGalleryModal();
}